import React, { createContext, useContext, useEffect, useState, useMemo } from "react";
import { api } from "@/lib/api";

const SiteContentContext = createContext({ c: (k, d) => d, nav: [], media: {}, ready: false, reload: () => {} });
export const useSiteContent = () => useContext(SiteContentContext);

export const SiteContentProvider = ({ children }) => {
  const [content, setContent] = useState({});
  const [nav, setNav] = useState([]);
  const [media, setMedia] = useState({});
  const [ready, setReady] = useState(false);

  const load = () => {
    api.get("/site-content").then((r) => setContent(r.data || {})).catch((err) => console.error("Failed to load site content", err));
    api.get("/nav").then((r) => setNav(r.data || [])).catch((err) => console.error("Failed to load nav", err));
    api.get("/site-media/full").then((r) => setMedia(r.data || {})).catch((err) => console.error("Failed to load media", err)).finally(() => setReady(true));
  };
  useEffect(() => { load(); }, []);

  const value = useMemo(() => ({
    c: (key, fallback = "") => (content[key] !== undefined ? content[key] : fallback),
    nav, media, ready, reload: load,
  }), [content, nav, media, ready]);

  return (
    <SiteContentContext.Provider value={value}>
      {children}
    </SiteContentContext.Provider>
  );
};
